<template>
    <div class="topic">
        <div v-if="topicInfo" class="topic-top">
            <div class="title">
                <span># {{topicInfo.content}} #</span>
                <img @click="handleShare" style="width: 16px;height: 16px" src="../../assets/share.png"/>
            </div>
            <div class="topic-info">
                <span>{{topicInfo.partNum}}人参与</span>
                <span>{{topicInfo.postNum}}条畅聊</span>
            </div>
        </div>
        <van-pull-refresh
        v-if="list.length || loading"
        v-model="refreshing"
        @refresh="onRefresh"
        success-text="刷新成功">
            <van-list
            v-model="loading"
            :finished="finished"
            finished-text="没有更多了"
            @load="onLoad"
            style="margin-top:10px;padding-bottom:50px;"
            >
            <BbsCard
            v-for="item in list"
            :key="item.id"
            @refresh="handleRefresh"
            :rowData="item" />
            </van-list>
        </van-pull-refresh>
        <div @click="handleLinkEdit" class="add-question">
            <img src="../../assets/edit-icon.png" class="edit-icon" alt="">
        </div>
    </div>
</template>
<script>
import BbsCard from './../article/components/bbsCard.vue';
import api from '@/api';
import { mapActions } from 'vuex';

export default {
    components: {
        BbsCard
    },
    data() {
        return {
            list: [],
            topicInfo: null,
            loading: false,
            finished: false,
            refreshing: false,
            pageParams: {
                page: 1,
                pageSize: 10
            },
        }
    },
    computed: {
        topicText() {
            return this.$route.query?.topic ? decodeURIComponent(this.$route.query?.topic) : '';
        }
    },
    watch: {
        topicText: {
            immediate: true,
            handler() {
                this.getTopicDetail();
            }
        }
    },
    mounted() {
        document.body.scrollTop = document.documentElement.scrollTop = 0
        this.handleBack();
    },
    methods: {
        ...mapActions(['updateUserInfoList']),
        handleBack() {
            const _this = this
            let options = {
                disabled: true,
                callback: function() {
                if (window.history.length > 1) {
                    _this.$router.go(-1)
                } else {
                    _this.$router.replace({ name: 'articleList', query: { type: 1} })
                }
                }
            }
            window.jme.browser.setGoBackDisabled(options)
        },
        async getTopicDetail(refresh = false) {
            try {
                if (!refresh) this.list = [];
                this.finished = false
                this.pageParams.page = 1 
                const { code, data } = await api.fetchTopicInfo(this.topicText);
            if (code === 200) {
                if (!data) {
                    return;
                }
                this.topicInfo = data;
                if (!refresh) this.getTopicList(data.id);
            }
            } catch (err) {
                this.topicInfo = null;
            }
        },
        onRefresh() {
            this.finished = false
            this.pageParams.page = 1 
            this.getTopicDetail()
        },
        onLoad() {
            this.pageParams.page++
            this.getTopicList()
        },
        async getTopicList(topicId = this.topicInfo?.id) {
            this.loading = true
            const params = {
                ...this.pageParams,
                fromH5: 1,
                topicId
            }
            api.getTopicList(params).then(res => {
                this.loading = false
                const { code, data, totalCount } = res
                if (this.refreshing) {
                    this.refreshing = false
                }
                if (code === 200) {
                if (this.pageParams.page > 1) {
                    this.list = this.list.concat(data)
                } else {
                    this.list = data
                }
                const userIds = data?.map((item) => item.userId);
                if (userIds?.length) {
                    this.updateUserInfoList(userIds.join())
                }
                if (this.list.length >= totalCount) {
                    this.finished = true
                }
                }
            })
        },
        handleShare() {
            let url = `http://sd.jd.com/topic?topic=${encodeURIComponent(this.topicText)}&isHideShareButton=1`;
            let title = `#${this.topicText}#`;
            let content = '一起来参与话题讨论吧！';
            const options = {
                shareData: {
                title,
                content,
                url,
                icon: 'https://s3.cn-north-1.jdcloud-oss.com/shendengbucket1/2023-02-28-17-07uAVeSgG0YYEUaxf.png',
                },
                typeList: ['JDMESession', 'CopyLink'],
                callback: function() {
                }
            }
            window.jme.share.shareCustom(options)
        },
        handleRefresh(val, type) {
            if (val) {
                if (type === 'vote') {
                    this.list = this.list.map(item => {
                        if (item.id === val.id) {
                            item = Object.assign(item, {...val})
                        }
                        return item
                    });
                    this.getTopicDetail(true);
                    return;
                }
                if (type === 'share') {
                    this.list = this.list.map(item => {
                        if (item.id === val.id) {
                            item = Object.assign(item, { sharedNum: val.sharedNum })
                        }
                        return item
                    })
                    this.getTopicDetail(true);
                    return;
                }
                let up
                let upNum
                if (val.isUp === '踩') {
                    up = val.isUp === '踩' ? -1 : 1
                    upNum = val.upNum
                } else {
                    up = val.isUp === 1 ? -1 : 1
                    upNum = val.isUp === 1 ? val.upNum - 1 : val.upNum + 1 
                }
                this.list = this.list.map(item => {
                    if (item.id === val.id) {
                        item = Object.assign(item, { isUp: up, upNum })
                    }
                    return item
                });
                this.getTopicDetail(true);
            } else {
                this.getTopicDetail();
            }
        },
        handleLinkEdit() {
            const query = {
                topic: this.topicText
            };
            this.$router.push({ name: 'release', query })
        }
    }
}
</script>
<style lang="less" scoped>
.topic {
    position: relative;
    .add-question {
        position: fixed;
        right: 5px;
        bottom: 120px;
        width: 56px;
        height: 56px;
        color: #fff;
    }
    .edit-icon {
        display: flex;
        align-items: center;
        height: 100%;
        justify-content: center;
    }
}
.topic-top {
    text-align: left;
    background: #fff;
    position: sticky;
    margin: 0 8px;
    border-radius: 8px;
    padding: 12px;
    .title {
        font-size: 16px;
        font-weight: bold;
        margin-bottom: 4px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        img {
            flex-shrink: 0;
            margin-left: 8px;
        }
    }
    .topic-info {
        color: #bfbfbf;
        font-size: 12px;
        & > span {
            margin-right: 12px;
        }
    }
}
</style>